import React from 'react';
import { priceFormatter } from 'ReactApp/Services/Formatters/PriceFormatter';
import { motion } from 'framer-motion';
import splitLine from 'ReactApp/Services/MotionHelpers/SplitLine';
import { ShowableProductCard } from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { observer } from "mobx-react";

const sentence = {
    visible: {
        transition: {
            delay: 1,
            staggerChildren: 0.05,
            staggerDirection: 1,
        },
    },
}

type BuyViaCreditV1Props = {
    productCard: ShowableProductCard
}

const BuyViaCreditV1 = observer((props: BuyViaCreditV1Props) => {

    let part: number | null = null;
    let wrapClasses: string[] = [
        'info-block-v1',
        'box-v1 box-v1_filling-type-contained',
        'box-v1_filling-color-type-gray',
        'info-block-v1_text-color-type-gray'
    ];

    if (
        props.productCard.salePrice === null
    ) {
        wrapClasses.push('_hide');
    } else {
        part = Math.round(props.productCard.salePrice.value / 6);
    }


    return (
        <div className={wrapClasses.join(' ')}>
            {part !== null && (
                <motion.div
                    className='info-block-v1__content'
                    variants={sentence}
                    initial="hidden"
                    animate="visible"
                >
                    {splitLine(
                        `В рассрочку от ${priceFormatter.format(part)} в месяц — без переплат`
                    )}
                </motion.div>
            )}
        </div>
    );

})

export default BuyViaCreditV1;